import { render, staticRenderFns } from "./AssetTypes.vue?vue&type=template&id=c5daabc0&scoped=true&"
import script from "./AssetTypes.vue?vue&type=script&lang=js&"
export * from "./AssetTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5daabc0",
  null
  
)

export default component.exports